import Vue from 'vue';
import App from './app.vue';
import ViewUI from 'view-design';
import router from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';

import { $http, $util, appConst } from '@/lib'
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import store from './store/index';
import Directive from './directive/index';
import Components from './components/index';
import VueI18n from 'vue-i18n'
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import 'vxe-table-plugin-iview/dist/style.css'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'
import config from '@/config'
import "echarts"
import echarts from "vue-echarts"
import VuePicturePreview from 'vue-picture-preview'  //引入图片查看器

Vue.use(VueI18n); 
Vue.use(VuePicturePreview);
Vue.config.productionTip = false;

/*指令注册*/
Directive.install(Vue);
/*组件注册*/
Components.install(Vue);
Vue.component('echarts', echarts);

Vue.prototype.$util = $util;
Vue.prototype.$appconst = appConst;  
if (!window.basic.utils.getCookieValue('Localization.CultureName')) {
  let language = navigator.language;
  window.basic.utils.setCookieValue('Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), window.basic.appPath);
}

const initVue = () => {
    $http.get("UserConfiguration/GetAll").then(data => {
        let result = data.data.result;
        $util.basic.localization = $util.extend(true, $util.basic.localization, result);
        store.commit("app/setSystemCode", result.systemCode)
        //设置iView语言包
        let localLang = result.currentLanguageName;
        window.basic.utils.setCookieValue('Localization.CultureName', localLang, new Date(new Date().getTime() + 5 * 365 * 86400000), window.basic.appPath);
        let lang = localLang === "zh-Hans"?"zh-CN": "en";
        let i18n = new VueI18n({ locale: lang, messages: { 'zh': zh, 'en': en }});
        Vue.use(ViewUI, { i18n: (key, value) => i18n.t(key, value)});

        let vxeLang = localLang === "zh-Hans"?"zh_CN": "en";
        let vxeI18n = new VueI18n({ locale: vxeLang,  messages:{ 'zh':{...zhCN }, 'en': { ...enUS } } });
        Vue.use(VXETable, { vxeI18n: (key, value) => i18n.t(key, value)});// 对组件内置的提示语进行国际化翻译

        new Vue({
            render: h => h(App),
            router: router,
            store: store,
            data: {
                currentPageName: ''
            },
            async mounted() {
                this.currentPageName = this.$route.name as string;
            }
        }).$mount('#app')
    });
}

if(config.enableSSO){
    if(process.env.NODE_ENV == "development") {
        //development
        initVue();
    } else if(process.env.VUE_APP_ENABLE_SSO == "false") {
        //sit
        initVue();
    } else{
        //uat prod
        if(!window.basic.utils.getToken()){
            $http.post("SSOAuth/Authenticate").then(response => {
                window.basic.utils.setToken(response.data.result.accessToken, null);
                initVue();
            });
        }else{
            initVue();
        }
    }
}else{
    initVue();
}



